@for (group of groups | orderBy:'Group'; track group) {
<forge-expansion-panel [open]="group.Open" (forge-expansion-panel-toggle)="toggle($event, group)">
  <forge-list-item slot="header" class="card-list--border-bottom">
    <button type="button" class="card-list--expand-button-{{depth}} forge-typography--heading2">{{group.Group}}
      ({{group.Count}})</button>
    <forge-open-icon slot="end"></forge-open-icon>
  </forge-list-item>
  <div>
    @if (group.Open) {
    <forge-list>
      <ng-container *ngTemplateOutlet="group.Entities ? entityCards : subGroup; context: { $implicit: group }">
      </ng-container>
    </forge-list>
    }
  </div>
</forge-expansion-panel>
}

<ng-template #subGroup let-group>
  <card-list-group [depth]="depth + 1" [view]="view" [groups]="group.Groups" [datacontroller]="datacontroller"
    [hasBody]="hasBody"></card-list-group>
</ng-template>

<ng-template #entityCards let-group>
  @for (model of group.Entities; track model) {
  <forge-card>
    <forge-expansion-panel class="card-list-item-header">
      <card-list-item-header slot="header" [cardMetadata]="view.Card" [model]="model" [datacontroller]="datacontroller"
        [hasBody]="hasBody"></card-list-item-header>
      @if (hasBody) {
      <card-list-item-body [cardMetadata]="view.Card" [dense]="view.Dense" [model]="model"></card-list-item-body>
      }
    </forge-expansion-panel>
  </forge-card>
  }
</ng-template>